module.exports = __webpack_public_path__ + "media/images/illustration_9-3612a7232ade56fc048958712196d014.png";